<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <!-- <div class="countryList">
        <div class="country">
          <span>行政区划：</span>
        </div>
        <div class="country">
          <span @click="setAllCheck()" :class="{ countryon: all }">全部</span>
        </div>
        <div class="country" v-for="(item,index) in towns" :key="index">
          <span @click="setListCheck(index, item.adcd)" :class="{ countryon: item.check }">{{item.adnm}}</span>
        </div>
      </div> -->
      <townName ref="townlist" v-on:townadcd="townAdcd"></townName>
      <div class="yuliang" ref="yuliang">
        <div class="select">
          <span class="desc">获取累计雨量:</span>
          <div class="block" style="display: inline-block;">
            <el-date-picker
              v-model="beginTime"
              :picker-options="Global.pickerOptionsStart(endTime)"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始时间"
              default-time="08:00:00"
              @change="Global.emptyQuery(beginTime, search)"
            >
            </el-date-picker>
            <span class="desc">至</span>
            <el-date-picker
              v-model="endTime"
              :picker-options="Global.pickerOptionsEnd(beginTime)"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择结束时间"
              default-time="08:00:00"
              @change="Global.emptyQuery(endTime, search)"
            >
            </el-date-picker>
          </div>
          <span class="desc">站名:</span>
          <div class="block" style="display: inline-block;">
            <el-select v-model="stasearchName" filterable clearable placeholder="请选择">
              <el-option v-for="item in staarr" :key="item.id" :label="item.stnm" :value="item.stnm"> </el-option>
            </el-select>
          </div>
          <span @click="search" id="select">查询</span>
          <span id="export" @click="exportdata"><span class="export-icon"></span>导出</span>
        </div>
        <div class="ylBlock" ref="ylBlock">
          <div class="ssyl ">
            <div class="rainTitle">
              <span class="yu">实时雨量[{{ this.date2 }}-{{ this.date1 }}]</span>
            </div>
            <div class="maxRain">
              <div class="max">
                <span>最大：</span>
                <span>{{ this.nameOfMaxRainNow }}</span>
              </div>
              <div class="maxNo">
                <span class="rainnum">{{ this.maxRainNow }}</span>
                <span>mm</span>
              </div>
            </div>
            <div class="average">
              <div class="max">
                <span>平均值</span>
              </div>
              <div class="maxNo">
                <span class="rainnum">{{ this.avgRainNow }}</span>
                <span>mm</span>
              </div>
            </div>
          </div>
          <div class="thirtyRain ">
            <div class="rainTitle">
              <span class="yu">30分钟雨量</span>
            </div>
            <div class="maxRain">
              <div class="max">
                <span>最大：</span>
                <span>{{ this.nameOfMaxRain30 }}</span>
              </div>
              <div class="maxNo">
                <span class="rainnum">{{ this.maxRain30 }}</span>
                <span>mm</span>
              </div>
            </div>
            <div class="average">
              <div class="max">
                <span>平均值</span>
              </div>
              <div class="maxNo">
                <span class="rainnum">{{ this.avgRain30 }}</span>
                <span>mm</span>
              </div>
            </div>
          </div>
          <div class="oneHour ">
            <div class="rainTitle">
              <span class="yu">1小时雨量</span>
            </div>
            <div class="maxRain">
              <div class="max">
                <span>最大：</span>
                <span>{{ this.nameOfMaxRain1 }}</span>
              </div>
              <div class="maxNo">
                <span class="rainnum">{{ this.maxRain1 }}</span>
                <span>mm</span>
              </div>
            </div>
            <div class="average">
              <div class="max">
                <span>平均值</span>
              </div>
              <div class="maxNo">
                <span class="rainnum">{{ this.avgRain1 }}</span>
                <span>mm</span>
              </div>
            </div>
          </div>
          <div class="historyRain ">
            <div class="threeHours">
              <div class="rainTitle">
                <span class="yu">3小时最大</span>
              </div>
              <div class="maxRain2">
                <div class="max">
                  <span>{{ this.nameOfMaxRain3 }}</span>
                </div>
                <div class="maxNo">
                  <span class="rainnum">{{ this.maxRain3 }}</span>
                  <span>mm</span>
                </div>
              </div>
            </div>
            <div class="sixHours">
              <div class="rainTitle">
                <span class="yu">6小时最大</span>
              </div>
              <div class="maxRain2">
                <div class="max">
                  <span>{{ this.nameOfMaxRain6 }}</span>
                </div>
                <div class="maxNo">
                  <span class="rainnum">{{ this.maxRain6 }}</span>
                  <span>mm</span>
                </div>
              </div>
            </div>
            <div class="twentyfour">
              <div class="rainTitle">
                <span class="yu">24小时最大</span>
              </div>
              <div class="maxRain2">
                <div class="max">
                  <span>{{ this.nameOfMaxRain24 }}</span>
                </div>
                <div class="maxNo">
                  <span class="rainnum">{{ this.maxRain24 }}</span>
                  <span>mm</span>
                </div>
              </div>
            </div>
            <div class="yesterday">
              <div class="rainTitle">
                <span class="yu">昨日最大</span>
              </div>
              <div class="maxRain2">
                <div class="max">
                  <span>{{ this.nameOfMaxRainYesterday }}</span>
                </div>
                <div class="maxNo">
                  <span class="rainnum">{{ this.maxRainYesterday }}</span>
                  <span>mm</span>
                </div>
              </div>
            </div>
            <div class="today">
              <div class="rainTitle">
                <span class="yu">今日最大</span>
              </div>
              <div class="maxRain2">
                <div class="max">
                  <span>{{ this.nameOfMaxRainToday }}</span>
                </div>
                <div class="maxNo">
                  <span class="rainnum">{{ this.maxRainToday }}</span>
                  <span>mm</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="raintable" ref="raintable">
          <div class="table-head">
            <u-table ref="plTable" border use-virtual :excess-rows="5" :row-height="48" v-loading="loading" :max-height="height" style="width: 100%;">
              <u-table-column width="70" label="序号" align="center" header-align="center">
                <template slot-scope="scope">
                  <div>{{ scope.$index + 1 }}</div>
                </template>
              </u-table-column>
              <u-table-column prop="appName" label="乡镇" align="center" sortable min-width="70">
                <template slot-scope="scope">
                  <div class="font_left">{{ scope.row.appName }}</div>
                </template>
              </u-table-column>
              <u-table-column prop="stationName" label="站名" align="center" sortable min-width="100">
                <template slot-scope="scope">
                  <!-- <div class="overflowWarn">
                    <span @click="stationchart(scope.row)" style="cursor:pointer!important;font-weight:bold">{{ scope.row.stnm }}</span>
                  </div> -->
                  <el-tooltip effect="dark" :content="scope.row.stnm + ' ' + (scope.row.stcd?scope.row.stcd:'')" placement="top" class="item" popper-class="hiddenOverflow">
                    <div class="overflowWarn">
                      <span @click="stationchart(scope.row)" style="cursor:pointer!important;font-weight:bold">{{ scope.row.stationName }}</span>
                    </div>
                  </el-tooltip>
                </template>
              </u-table-column>
              <u-table-column prop="sttp" label="来源" min-width="50" align="center" header-align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.sttp.includes('PP')"> 水文</span>
                  <span v-else-if="scope.row.sttp == 'MM'"> 气象</span>
                </template>
              </u-table-column>
              <u-table-column prop="reportTime" label="最新时间" align="center" min-width="100" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.reportTime.slice(5) }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="accRain" label="累计" min-width="70" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.accRain | rounding }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="rainNow" :label="'实时雨量@[' + date2 + '-' + date1 + ']'" :render-header="renderheader" min-width="80" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.rainNow | rounding }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="rainHalfOneHourBefore" label="30分钟" min-width="70" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.rainHalfOneHourBefore | rounding }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="rainOneHourBefore" label="1小时" min-width="70" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span :style="scope.row.rainOneHourBefore >= 30 ? 'color:orange' : ''">{{ scope.row.rainOneHourBefore | rounding }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="rainThreeHoursBefore" label="3小时" min-width="70" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span :style="scope.row.rainThreeHoursBefore >= 50 ? 'color:orange' : ''">{{ scope.row.rainThreeHoursBefore | rounding }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="rainSixHoursBefore" label="6小时" min-width="70" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.rainSixHoursBefore | rounding }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="rain24HoursBefore" label="24小时" min-width="70" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span :style="scope.row.rain24HoursBefore >= 100 ? 'color:orange' : ''">{{ scope.row.rain24HoursBefore | rounding }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="rainYesterday" label="昨日" min-width="70" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.rainYesterday | rounding }}</span>
                </template>
              </u-table-column>
              <u-table-column prop="rainToday" label="今日" min-width="70" align="center" header-align="center" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.rainToday | rounding }}</span>
                </template>
              </u-table-column>
            </u-table>
          </div>
        </div>
      </div>
    </div>
    <stationDialog ref="stationDialog"></stationDialog>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
import townName from '@/components/Townname'
import stationDialog from '@/components/stationDialog'
export default {
  name: 'MonitoringCenter',
  components: {
    townName,
    stationDialog
  },
  data() {
    return {
      height: 10,
      loading: true,
      loading1: true,
      aDDVCD: '',
      appType: '1',
      beginTime: '',
      endTime: '',
      isTown: true,
      searchName: '',
      pageIndex: '1',
      pageSize: '100',
      nameOfMaxRainNow: '',
      maxRainNow: '',
      avgRainNow: '',
      nameOfMaxRain30: '',
      maxRain30: '',
      avgRain30: '',
      nameOfMaxRain1: '',
      maxRain1: '',
      avgRain1: '',
      nameOfMaxRain3: '',
      nameOfMaxRain6: '',
      nameOfMaxRain24: '',
      nameOfMaxRainYesterday: '',
      nameOfMaxRainToday: '',
      maxRain3: '',
      maxRain6: '',
      maxRain24: '',
      maxRainYesterday: '',
      maxRainToday: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      towns: [],
      exportform: {},
      date1: '',
      date2: '',
      sTID: '',
      time: '',
      chartwaterValues: [],
      chartxline: [],
      chartwrZs: [],
      chartrainValues: [],
      datev: '',
      radio: '1',
      dateselect: true,
      thestation: '',
      dialogVisible: false,
      sID: 22,
      myChart: {},
      stasearchName: '',
      staarr: []
    }
  },
  computed: {},
  methods: {
    // 行政区划选择
    townAdcd: function(townAdcd) {
      this.loading = true
      this.aDDVCD = townAdcd
      this.tabledata()
    },
    // 表头换行
    renderheader(h, { column, $index }) {
      return h('span', {}, [h('span', {}, column.label.split('@')[0]), h('br'), h('span', {}, column.label.split('@')[1])])
    },
    stationchart(item) {
      this.$refs.stationDialog.showlog(item, '#2F4F4F')
    },
    nowpoint() {
      let thedate = new Date()
      let hours = thedate.getHours()
      let minutes = thedate.getMinutes()
      this.date1 = this.conver(hours) + ':' + this.conver(minutes)
      this.date2 = this.conver(hours) + ':' + '00'
    },
    conver(s) {
      return s < 10 ? '0' + s : s
    },
    exportdata() {
      let obj = {
        aDDVCD: this.aDDVCD,
        appType: this.appType,
        beginTime: this.beginTime,
        endTime: this.endTime,
        mainStation: true
      }
      this.global.setTimeInterval(obj, 'beginTime', 'endTime')
      this.$store.dispatch(monitorTypes.EXPORT_REALTIME_RAIN, obj).then((data) => {
        window.location.href = this.Global.basePath + data.data
        // window.location.href
      })
    },
    // 计算表格高度及背景高度
    towndata() {
      let arr = []
      this.$store
        .dispatch(monitorTypes.GET_ADCD, {
          isTown: this.isTown,
          searchName: this.searchName,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        })
        .then((data) => {
          this.adcdtotal = data.total
          this.towns = data.results
          this.towns.forEach((item) => {
            let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
            obj.adcd = item.adcd
            obj.adnm = item.adnm
            obj.id = item.id
            arr.push(obj)
          })
          this.towns = arr
        })
    },
    tabledata() {
      this.loading = true
      let obj = {
        aDDVCD: this.aDDVCD,
        sID: this.sID,
        StationName: this.stasearchName,
        appType: this.appType,
        mainStation: true,
        beginTime: this.beginTime,
        endTime: this.endTime
      }
      this.global.setTimeInterval(obj, 'beginTime', 'endTime')
      this.$store.dispatch(monitorTypes.GET_STATISTICS_RAIN, obj).then((data) => {
        if (this.stasearchName === '') {
          this.staarr = data.rows
        }
        this.tdata = data.rows
        this.$refs.plTable.reloadData(this.tdata) // 列表加载优化
        this.loading = false
        // let name = data.rows.appName === '' ? '' : data.rows.appName
        // 实时雨量
        this.nameOfMaxRainNow = data.nameOfMaxRainNow
        this.maxRainNow = data.maxRainNow
        this.avgRainNow = data.avgRainNow
        // 30分钟雨量
        this.nameOfMaxRain30 = data.nameOfMaxRain30
        this.maxRain30 = data.maxRain30
        this.avgRain30 = data.avgRain30
        // 一小时雨量
        this.nameOfMaxRain1 = data.nameOfMaxRain1
        this.maxRain1 = data.maxRain1
        this.avgRain1 = data.avgRain1
        // 三小时之后
        this.nameOfMaxRain3 = data.nameOfMaxRain3
        this.nameOfMaxRain6 = data.nameOfMaxRain6
        this.nameOfMaxRain24 = data.nameOfMaxRain24
        this.nameOfMaxRainYesterday = data.nameOfMaxRainYesterday
        this.nameOfMaxRainToday = data.nameOfMaxRainToday
        this.maxRain3 = data.maxRain3
        this.maxRain6 = data.maxRain6
        this.maxRain24 = data.maxRain24
        this.maxRainYesterday = data.maxRainYesterday
        this.maxRainToday = data.maxRainToday
      })
    },
    search: function() {
      this.tabledata()
    }
  },
  filters: {
    rounding(num) {
      var result = parseFloat(num)
      if (isNaN(result)) {
        return '-'
      } else if (result === 0) {
        return num
      }
      result = Math.round(num * 100) / 100
      var value = result.toString() // 将数字转换为字符串

      let posdecimal = value.indexOf('.') // 小数点的索引值

      // 当整数时，posdecimal=-1 自动补0
      if (posdecimal < 0) {
        posdecimal = value.length
        value += '.'
      }

      // 当数字的长度< 小数点索引+2时，补0
      while (value.length <= posdecimal + 1) {
        value += '0'
      }
      // console.log(typeof value)
      // let val = parseFloat(value)
      return value
    }
  },
  mounted() {
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.nowpoint()
      _this.tabledata()
    }, 60000)
    this.nowpoint()
    this.towndata()
    this.tabledata()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45 + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - this.$refs['ylBlock'].offsetHeight - 25 - selectDiv[0].offsetHeight
    })
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style scoped>
/* .monitor >>> .el-input__inner{
  width: 85%;
} */
body {
  background-color: #f0f2f6;
  margin: 0;
  padding: 0 0 10px 0;
}
.select .desc {
  font-size: 16px;
  font-family: Microsoft YaHei UI;
  margin-left: 20px;
  margin-top: 5px;
  color: #444444;
  margin-right: 18px;
  line-height: 26px;
}
#export {
  padding: 9px 8px;
  background-color: #3d72fb;
  cursor: pointer;
  float: right;
  color: #ffffff;
  border-radius: 3px;
  margin-right: 20px;
  font-size: 16px;
}
.export-icon {
  width: 18px;
  height: 17px;
  display: inline-block;
  background-image: url(../../../assets/monitorimg/export.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-right: 5px;
  vertical-align: middle;
}
.ylBlock {
  margin-top: 5px;
  height: 120px;
  overflow: hidden;
}
.ylBlock > div {
  height: 120px;
}
.ssyl {
  width: 17.1%;
  float: left;
  /* margin-top: 10px; */
  margin-left: 0.5%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(../../../assets/monitorimg/lanse.png);
}
.thirtyRain {
  width: 17.1%;
  float: left;
  /* margin-top: 10px; */
  margin-left: 1.3%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(../../../assets/monitorimg/chengse.png);
}
.oneHour {
  width: 17.1%;
  float: left;
  /* margin-top: 10px; */
  margin-left: 1.3%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(../../../assets/monitorimg/qianlan.png);
}
.historyRain {
  width: 43.2%;
  float: left;
  /* margin-top: 10px; */
  margin-left: 1.3%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(../../../assets/monitorimg/lvse.png);
}
.rainTitle {
  font-family: Microsoft YaHei UI;
  font-size: 16px;
  color: #fcfcfc;
  text-align: center;
  width: 100%;
  height: 40px;
  padding-top: 10px;
}
.maxRain {
  width: 60%;
  height: 70px;
  float: left;
  color: #fcfcfc;
  font-size: 16px;
  text-align: center;
}
.maxRain2 {
  width: 100%;
  height: 70px;
  float: left;
  color: #ffffff;
  text-align: center;
}
.max {
  font-size: 16px;
  margin-top: 10px;
  width: 100%;
  float: left;
}
.rainnum {
  font-family: Arial;
  font-size: 26px;
}
.maxNo {
  width: 100%;
  float: left;
  margin-top: 10px;
}
.average {
  width: 40%;
  height: 70px;
  float: left;
  color: #ffffff;
  text-align: center;
  margin-left: -6px;
}
.yu {
  display: block;
}
.threeHours,
.sixHours,
.twentyfour,
.yesterday,
.today {
  width: 19.5%;
  height: 100%;
  float: left;
}
.threeHours {
  margin-left: 1%;
}
.table-head {
  color: #333333;
  width: 100%;
  /* margin-left: 1%; */
  background-color: #eaf1fa;
}
.table-body {
  color: #666666;
  width: 100%;
  /* margin-left: 1%; */
}
.table-body table {
  display: inline-block;
  height: 500px;
  overflow-y: auto;
}
.table-body table tr:nth-child(odd) {
  background: #eaf1fa;
}
/* .table-body table tr:nth-child(even) {
    background: #eaf1fa;
} */
.zuidayuliang {
  width: 100%;
  float: left;
}
div.table-head table,
div.table-body table {
  width: 100%;
}
div.table-head table thead tr th,
.table-body table tr td {
  line-height: 30px;
  text-align: left;
  color: #333333;
}
div.table-head table thead tr th {
  line-height: 35px;
}
td {
  border: 0;
}
.table-head table thead tr th:nth-of-type(1),
.table-body table tr td:nth-of-type(1) {
  width: 10%;
  padding-left: 2%;
}
.table-head table thead tr th:nth-of-type(2),
.table-body table tr td:nth-of-type(2) {
  width: 11%;
}
.table-head table thead tr th:nth-of-type(3),
.table-body table tr td:nth-of-type(3) {
  width: 12%;
}
.table-head table thead tr th:nth-of-type(4),
.table-body table tr td:nth-of-type(4) {
  width: 7%;
}
.table-head table thead tr th:nth-of-type(5),
.table-body table tr td:nth-of-type(5) {
  width: 7%;
}
.table-head table thead tr th:nth-of-type(6),
.table-body table tr td:nth-of-type(6) {
  width: 7%;
}
.table-head table thead tr th:nth-of-type(7),
.table-body table tr td:nth-of-type(7) {
  width: 7%;
}
.table-head table thead tr th:nth-of-type(8),
.table-body table tr td:nth-of-type(8) {
  width: 7%;
}
.table-head table thead tr th:nth-of-type(9),
.table-body table tr td:nth-of-type(9) {
  width: 7%;
}
.table-head table thead tr th:nth-of-type(10),
.table-body table tr td:nth-of-type(10) {
  width: 7%;
}
.table-head table thead tr th:nth-of-type(11),
.table-body table tr td:nth-of-type(11) {
  width: 7%;
}
.table-head table thead tr th:nth-of-type(12) {
  width: 7%;
}
.table-body table tr td:nth-of-type(1) {
  width: 191px;
  padding-left: 2%;
}
.table-body table tr td:nth-of-type(2) {
  width: 212px;
}
.table-body table tr td:nth-of-type(3) {
  width: 240px;
}
.table-body table tr td:nth-of-type(4),
.table-body table tr td:nth-of-type(5),
.table-body table tr td:nth-of-type(6),
.table-body table tr td:nth-of-type(7),
.table-body table tr td:nth-of-type(8),
.table-body table tr td:nth-of-type(9),
.table-body table tr td:nth-of-type(10),
.table-body table tr td:nth-of-type(11) {
  width: 135px;
}
.table-body table tr td:nth-of-type(12) {
  width: 6.5%;
}
.yuliang >>> .el-date-editor.el-input,
.yuliang >>> .el-date-editor.el-input__inner {
  width: 190px;
}
#station {
  width: 100%;
  height: 400px;
}
.block1 {
  position: absolute;
  width: 95%;
  top: 15px;
  left: 0;
  text-align: center;
}
</style>
